import { Container } from '@/components/layout/Container';
import { Section } from '@/components/layout/Section';
import { ProductGrid } from '@/components/product/ProductGrid/ProductGrid';
import { useProductStore } from '@/store/productStore';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export const FeaturedSection = () => {
  const products = useProductStore((state) => state.products);
  const featuredProducts = products.filter((p) => p.isFeatured).slice(0, 4);

  return (
    <Section>
      <Container>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-2">
                Featured Products
              </h2>
              <p className="text-gray-600">
                Discover our most popular gaming controllers
              </p>
            </div>

            <Link to="/shop">
              <Button variant="ghost" className="gap-2 hover:gap-3 transition-all">
                View All
                <ArrowRight className="w-4 h-4" />
              </Button>
            </Link>
          </div>

          <ProductGrid products={featuredProducts} />
        </motion.div>
      </Container>
    </Section>
  );
};
